import React, { useState, useRef, useEffect, useCallback } from 'react';
import { API } from '../config';

async function smartParse(text) {
  try {
    const r = await fetch(`${API.apiBase}/api/parse-input`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text })
    });
    if (!r.ok) return {};
    return await r.json();
  } catch {
    return {};
  }
}

export default function RegisterForm({ onRegister }) {
  const [mode, setMode] = useState('smart');
  const [smartInput, setSmartInput] = useState('');
  const [parsed, setParsed] = useState(null);
  const [name, setName] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [enrollYear, setEnrollYear] = useState('');
  const [gradYear, setGradYear] = useState('');
  const [className, setClassName] = useState('');
  const [headTeacher, setHeadTeacher] = useState('');
  const [phone, setPhone] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSugg, setShowSugg] = useState(false);
  const [searched, setSearched] = useState(false);
  const schoolRef = useRef(null);
  const suggRef = useRef(null);

  const searchSchools = useCallback(async (q) => {
    if (!q || q.length < 1) { setSuggestions([]); setShowSugg(false); setSearched(false); return; }
    try {
      const r = await fetch(`${API.apiBase}/api/schools/search?q=${encodeURIComponent(q)}`);
      if (!r.ok) return;
      const data = await r.json();
      setSuggestions(data);
      setSearched(true);
      setShowSugg(q.length >= 2);
    } catch { }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => searchSchools(schoolName), 150);
    return () => clearTimeout(timer);
  }, [schoolName, searchSchools]);

  useEffect(() => {
    function handleClick(e) {
      if (suggRef.current && !suggRef.current.contains(e.target) && schoolRef.current && !schoolRef.current.contains(e.target)) {
        setShowSugg(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  async function handleSmartSubmit() {
    const result = await smartParse(smartInput);
    setParsed(result);
    setSchoolName(result.schoolName || '');
    setEnrollYear(result.enrollYear || '');
    setGradYear(result.gradYear || '');
    setClassName(result.className || '');
    if (result.schoolName) setShowSugg(false);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch(API.users, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, schoolName, enrollYear, gradYear, className, headTeacher, phone, tags: ['校友'], preferences: ['校友互助'] })
      });
      if (!res.ok) { alert('API 错误: ' + res.status); return; }
      const user = await res.json();
      setDone(true);
      setTimeout(() => { if (onRegister) onRegister(user); }, 800);
    } catch (err) {
      alert('网络错误: ' + err.message);
    }
    setSubmitting(false);
  }

  if (done) return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>🎉</div>
      <div style={{ fontSize: 18, color: '#e91e63', fontWeight: 600, marginBottom: 8 }}>加入成功！</div>
      <div style={{ color: '#666', fontSize: 14 }}>正在进入班级留言板...</div>
      <div style={{ color: '#999', fontSize: 12, marginTop: 6 }}>填写班主任姓名可自动验证同班身份</div>
    </div>
  );

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 420, margin: '0 auto', textAlign: 'left' }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
        <button type="button" onClick={() => setMode('smart')} style={{ flex: 1, padding: '6px 0', border: 'none', borderRadius: 6, background: mode === 'smart' ? '#e91e63' : '#eee', color: mode === 'smart' ? '#fff' : '#666', fontSize: 13, cursor: 'pointer', fontWeight: 600 }}>
          AI 智能输入
        </button>
        <button type="button" onClick={() => setMode('manual')} style={{ flex: 1, padding: '6px 0', border: 'none', borderRadius: 6, background: mode === 'manual' ? '#e91e63' : '#eee', color: mode === 'manual' ? '#fff' : '#666', fontSize: 13, cursor: 'pointer', fontWeight: 600 }}>
          逐项填写
        </button>
      </div>

      {mode === 'smart' && (
        <div style={{ background: '#f8f4ff', border: '1px solid #e8dfff', borderRadius: 8, padding: 12 }}>
          <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>输入样例：<code style={{ background: '#eee', padding: '2px 6px', borderRadius: 4, fontSize: 12 }}>汕头二中 2028届 初三2班</code></div>
          <div style={{ display: 'flex', gap: 6 }}>
            <input
              value={smartInput}
              onChange={e => setSmartInput(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleSmartSubmit(); } }}
              placeholder="输入学校+届别+班级，AI自动识别"
              style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14 }}
            />
            <button type="button" onClick={handleSmartSubmit} style={{ padding: '8px 16px', border: 'none', borderRadius: 6, background: '#7c4dff', color: '#fff', fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' }}>
              解析
            </button>
          </div>
          {parsed && (
            <div style={{ marginTop: 8, padding: 8, background: '#e8f5e9', borderRadius: 6, fontSize: 12, lineHeight: 1.8 }}>
              <div>🏫 学校：{parsed.schoolName || <span style={{ color: '#999' }}>未识别</span>}</div>
              <div>📅 入学：{parsed.enrollYear || '-'}　毕业：{parsed.gradYear || '-'}　班级：{parsed.className || '-'}</div>
            </div>
          )}
        </div>
      )}

      <input value={name} onChange={e => setName(e.target.value)} placeholder="你的姓名" required style={s.input} />

      <div style={{ position: 'relative' }}>
        <input
          ref={schoolRef}
          value={schoolName}
          onChange={e => { setSchoolName(e.target.value); setShowSugg(true); }}
          onFocus={() => { if (suggestions.length > 0) setShowSugg(true); }}
          placeholder="母校名称（如：汕头市第一中学）" required style={s.input}
        />
        {showSugg && (
          <div ref={suggRef} style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ddd', borderRadius: 6, zIndex: 10, maxHeight: 200, overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
            {suggestions.map(s => (
              <div key={s.school_id} onClick={() => { setSchoolName(s.name); setShowSugg(false); }} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', fontSize: 13 }}>
                <span style={{ fontWeight: 600 }}>{s.name}</span>
                <span style={{ color: '#999', marginLeft: 8, fontSize: 12 }}>{s.level} · {s.region}</span>
              </div>
            ))}
            {searched && suggestions.length === 0 && schoolName.trim().length >= 2 && (
              <div onClick={() => { setShowSugg(false); }} style={{ padding: '10px 12px', cursor: 'pointer', borderTop: '1px dashed #ddd', fontSize: 13, color: '#e91e63' }}>
                ➕ 添加新学校「{schoolName}」（提交后自动创建）
              </div>
            )}
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <input value={enrollYear} onChange={e => setEnrollYear(e.target.value)} placeholder="入学年份（如：2018）" style={{ ...s.input, flex: 1 }} />
        <input value={gradYear} onChange={e => setGradYear(e.target.value)} placeholder="毕业年份（如：2021）" style={{ ...s.input, flex: 1 }} />
      </div>
      <input value={className} onChange={e => setClassName(e.target.value)} placeholder="班级（如：初三3班）" style={s.input} />
      <input value={headTeacher} onChange={e => setHeadTeacher(e.target.value)} placeholder="班主任姓名（如：李老师）" style={s.input} />
      <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="手机号（选填，联系请求通过后可见）" style={s.input} />
      <button type="submit" disabled={submitting} style={{ ...s.btn, opacity: submitting ? 0.6 : 1 }}>
        {submitting ? '加入中...' : '加入校友会'}
      </button>
    </form>
  );
}

const s = {
  input: { padding: '8px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, textAlign: 'left' },
  btn: { padding: '10px', border: 'none', borderRadius: 6, background: '#e91e63', color: '#fff', fontSize: 15, cursor: 'pointer' }
};